import * as React from 'react';
import type { SVGProps } from 'react';
const SvgThumbUpFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M16 16H0V0h16z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#7F7F7F"
        d="M14 5.6c.3 0 .575.122.825.367.25.244.375.522.375.833v.95a1.08 1.08 0 0 1-.1.467l-1.983 4.65c-.09.222-.234.4-.434.533-.2.133-.428.2-.683.2H5.6c-.333 0-.617-.114-.85-.342a1.15 1.15 0 0 1-.35-.858V6.1c0-.167.033-.325.1-.475.067-.15.156-.28.267-.392l3.35-3.35c.2-.2.444-.327.733-.383.289-.055.533-.022.733.1.256.145.42.356.492.633.072.278.08.55.025.817L9.6 5.6zm-12 8c-.322 0-.603-.12-.842-.358A1.152 1.152 0 0 1 .8 12.4V6.8c0-.322.12-.603.358-.842.24-.238.52-.358.842-.358.322 0 .603.12.842.358.239.24.358.52.358.842v5.6c0 .322-.12.603-.358.842-.24.239-.52.358-.842.358"
      />
    </g>
  </svg>
);
export default SvgThumbUpFilled;
